import { useCallback, useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import AlertBanner from "../../../components/AlertBanner";
import { connect } from "react-redux";
import { getAgreements } from "../../../modules/agreements/actions";
import AgreementsTable from "../../../modules/agreements/components/AgreementsTable";
import AgreementModal from "../../../modules/agreements/components/AgreementModal";

const AGREEMENTS_ONBOARD_QUERY = {
  // agreementType: "creator",
  isDefaultAgreement: true,
  // status: "InProgress",
  isRequired: true,
  requiresCreatorSignature: true,
  creatorHasSigned: false,
};

const AgreementsStep = ({
  loginUser,
  setNextButtonType,
  refreshUser,
  agreements,
  loading,
  getAgreements,
}) => {
  const [agreement_id, setAgreement_id] = useState(null);
  // HACK: force
  const [refreshDone, setRefreshDone] = useState(false);
  useEffect(() => {
    // TODO: this isn't running, idk why, fix later
    setNextButtonType(
      !loginUser?.__agreementMetrics?.userLevelRequiredIncomplete
        ? "finish"
        : "skip",
    );
  }, [
    loginUser?.__agreementMetrics?.userLevelRequiredIncomplete,
    setNextButtonType,
  ]);

  useEffect(() => {
    if (refreshDone) {
      setNextButtonType(
        !loginUser?.__agreementMetrics?.userLevelRequiredIncomplete
          ? "finish"
          : "skip",
      );
      setRefreshDone(false);
    }
  }, [
    refreshDone,
    loginUser?.__agreementMetrics?.userLevelRequiredIncomplete,
    setNextButtonType,
  ]);

  const fetchAgreements = useCallback(() => {
    getAgreements(AGREEMENTS_ONBOARD_QUERY);
  }, [getAgreements]);

  useEffect(() => {
    fetchAgreements();
  }, [fetchAgreements]);

  const syncData = useCallback(() => {
    fetchAgreements();
    refreshUser();
    setRefreshDone(true);
    // setNextButtonType(() => {
    //   console.log("syncData - calling setNextButtonType");

    //   return "finish";
    // });
  }, [fetchAgreements, refreshUser, setRefreshDone]);

  return (
    <div className="agreement-onboarding">
      <Row>
        <Col xs={12}>
          <div className="subheading">
            <h3 className="title">Sign Agreements</h3>
            <p className="text-grey mb-0">
              Sign the following agreements to continue.
            </p>
          </div>

          <AgreementModal
            agreement_id={agreement_id}
            setAgreement_id={setAgreement_id}
            onClosed={syncData}
          />
        </Col>
        {/* ???: which value to use for conditional? not sure if this isn't working cus test data and webhook issues */}
        {/* {loginUser?.__agreementMetrics?.userLevelRequiredIncomplete ? ( */}
        {agreements?.length > 0 ? (
          <Col xs="12">
            <AgreementsTable
              size="sm"
              agreementsQuery={AGREEMENTS_ONBOARD_QUERY}
              setAgreement_id={setAgreement_id}
            />
          </Col>
        ) : (
          <Col xs="12">
            <AlertBanner
              message="No onboarding agreement signatures currently required."
              alertType="success"
            />
            <p>
              <span className="text-grey">
                Additional agreements may be required in the future when joining
                new campaigns. You can always find all your agreements (signed
                and unsigned) in the
              </span>
              &nbsp;
              <a className="link-more" href={"/agreements"}>
                Agreements tab.
              </a>
            </p>
          </Col>
        )}
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    agreements: state.agreements.agreements,
    loading: state.agreements.loading,
  };
};
export default connect(mapStateToProps, {
  getAgreements,
})(AgreementsStep);
